// extracted by mini-css-extract-plugin
export default {"accordion":"accordion_accordion__Rf5F6","item":"accordion_item__roOz+","toggle":"accordion_toggle__tf85U","noIcon":"accordion_noIcon__1nypw","content":"accordion_content__S63kY"};